import React, { useEffect } from "react";
import DateInput from "../../library/components/DateInput";
import SelectField from "../../library/components/Select";
import {
  commonApi,
  useGetConstituencyRequestQuery,
  useGetPcByStateQuery,
} from "../../services/announceElection";
import { Validators } from "../../library/utilities/Validator";
import { useDispatch } from "react-redux";
import { useAnnounceElectionUploadFileMutation, useGetStatesRequestQuery } from "../../services/announceElection";
import Button from "../../library/components/Button";
import { useState } from "react";
import { createAlert } from "../../features/alert/alerts";
import { ALERT_TYPE_SUCCESS } from "../../constants/constants";
import moment from "moment/moment";
import "./announceElection.css";
import { downloadExcel } from "react-export-table-to-excel";
import { useGetAllDetailsAnnounceElectionMutation, useAnnounceElectionDetailEditMutation } from "../../services/announceElection";
import Table from "../../ui/datatable/DataTable";
import CustomModal from "../../library/components/Modal/modal";
import ConfirmationModal from "../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import excelIcon from "../../dashboardicon/excel.svg";
import MultiSelectCheckBox from "../../ui/multiSelectCheckbox/MultiSelectCheckBox"

const SingleComponent = ({ updateUserData }) => {
  let selectConst = []
  if (updateUserData) {
    selectConst = [{ label: `${updateUserData?.constNo} - ${updateUserData?.constName.slice(0, -6)}`, value: updateUserData?.constNo }]
  }
  const [updateAnnounceDetail, responseData] = useAnnounceElectionDetailEditMutation();
  const [selected, setSelected] = useState(selectConst)
  const getDateTime = (date) => {
    let sDate = date.split('-')
    return sDate[2] + '-' + sDate[1] + '-' + sDate[0]
  }
  let initialState = {
    electionType: "",
    constituenctType: "",
    state: "",
    selectPhase: "",
    statePhase: "",
    constituency: "",
    startDate: "",
    startTime: "15:00",
    endDate: "",
    endTime: "23:59",
    erollFinalisationDate: "",
    erollFinalisationTime: "15:00",
    cutOffDate: "",
    cutOffTime: "07:59",
    dateOfPoll: "",
    dateOfCompletion:"",
    Date_of_Announcement_of_Election: "",
    dateDisabled: {
      isDate_of_Announcement_of_Election: true,
      isEndDate: true,
      isErollFinalisationDate: true,
      isCutOffDate: true,
      isDateOfPoll: true,
      isStartDate: true,
    },
  };
  if (updateUserData) {
    initialState = {
      electionType: updateUserData.electionType === "GEN" ? "General" : "Bye",
      constituenctType: updateUserData.constType,
      statePhase: updateUserData.statePhaseNo,
      dateOfPoll: updateUserData.datePoll,
      dateOfCompletion: updateUserData.dateOfCompletion,
      selectPhase: updateUserData.phaseNo,
      state: updateUserData.stateCd,
      Date_of_Announcement_of_Election:updateUserData.gazetteDate,
      startDate: moment(getDateTime(updateUserData.startDateTime.split(" ")[0])).format('YYYY-MM-DD'),
      startTime: moment(updateUserData.startDateTime.substring(9,21), ["h:mm A"]).format("HH:mm"),
      cutOffDate: moment(getDateTime(updateUserData.cutOffDateTime.split(" ")[0])).format('YYYY-MM-DD'),
      cutOffTime: moment(updateUserData.cutOffDateTime.substring(9,21), ["h:mm A"]).format("HH:mm"),
      endDate: moment(getDateTime(updateUserData.endDateTime.split(" ")[0])).format('YYYY-MM-DD'),
      endTime: moment(updateUserData.endDateTime.substring(9,21), ["h:mm A"]).format("HH:mm"),
      erollFinalisationDate: moment(getDateTime(updateUserData.erollFinalDateTime.split(" ")[0])).format('YYYY-MM-DD'),
      erollFinalisationTime: moment(updateUserData.erollFinalDateTime.substring(9,21), ["h:mm A"]).format("HH:mm"),
      dateDisabled: {
        isDate_of_Announcement_of_Election:true,
        isEndDate: true,
        isErollFinalisationDate: true,
        isCutOffDate: true,
        isDateOfPoll: true,
        isStartDate: true,
      },
    }
  }

  const [states, setStates] = useState(initialState);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [getUsers] = useGetAllDetailsAnnounceElectionMutation();
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
  const [showConfirmationPopupForUpdateDetail, setShowConfirmationPopupForUpdateDetail] = useState(false)

  const tableHeader = [];
  const columns = [
    {
      Header: "S.No",
      accessor: "S_No",
    },
    {
      Header: "State",
      accessor: "stateCd",
    },
    {
      Header: "Election Type",
      accessor: "electionType",
    },
    {
      Header: "Constituency Type",
      accessor: "constType",
    },
    {
      Header: "Constituency",
      accessor: "constNo",
    },
    {
      Header: "Phase No",
      accessor: "phaseNo",
    },
    {
      Header: "State Phase No",
      accessor: "statePhaseNo",
    },
    {
      Header: "Date of Announcement of Election",
      accessor: "Date_of_Announcement_of_Election",
    },
    {
      Header: "Last date for the withdrawal of candidates",
      accessor: "startDateTime",
    },
    {
      Header: "End Date & Time",
      accessor: "endDateTime",
    },
    {
      Header: "Date of Poll",
      accessor: "datePoll",
    },
    {
      Header: "Cut-off Date & Time",
      accessor: "cutOffDateTime",
    },
    {
      Header: "Last Date of making nominations",
      accessor: "erollFinalDateTime",
    },
    {
      Header: "Date of Compeletion of Election",
      accessor: "dateOfCompletion",
    },
  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })
  const [isShowing, setIsShowing] = useState(true);
  const [Error, setError] = useState({});
  const [error, seterror] = useState({});
  const { data: getAllState } = useGetStatesRequestQuery();
  const [saveDetails] = useAnnounceElectionUploadFileMutation();
  const [tableData, setTableData] = useState([])
  const dispatch = useDispatch();

  const getElectionData = () =>{
  getUsers({ stateCd: "" }).unwrap()
  .then((res) => {
    let tableData1 = []
    res?.payload?.map((item, i) => {
      tableData1.push({
        "S_No": i + 1,
        "stateCd": item.stateName,
        "electionType": item.electionType,
        "constType": item.constType,
        "constNo": `${item.constNo} - ${item.constName}`,
        "phaseNo": item.phaseNo,
        "statePhaseNo": item.statePhaseNo,
        "Date_of_Announcement_of_Election":item.gazetteDate,
        "startDateTime": item.startDateTime,
        "endDateTime": item.endDateTime,
        "datePoll": item.datePoll,
        "cutOffDateTime": item.cutOffDateTime,
        "erollFinalDateTime": item.erollFinalDateTime,
        "dateOfCompletion" : item.dateOfCompletion
      });
    });
    setTableData(tableData1)
    setTotalNoOfRecords(res?.payload?.length)
  })
  .catch((error) => {
    setTableData([])
  })
}

  useEffect(() => {
   getElectionData()
  }, [])
  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success"
      })
    )
  }
  const handleChange = (key, value, i) => {
    if (key === "state" || key === "constituenctType") {
      setSelected([])
    }
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    if(key === "Date_of_Announcement_of_Election"){
      setStates((prevState) => ({
        ...prevState,
        ["erollFinalisationDate"]: "",
        ["startDate"]: "",
        ["endDate"]: "",
        ["cutOffDate"]: "",
        ["dateOfPoll"]: "",
      }));
    }
    if (key === "erollFinalisationDate") {
      setStates((prevState) => ({
        ...prevState,
        ["startDate"]: "",
        ["endDate"]: "",
        ["cutOffDate"]: "",
        ["dateOfPoll"]: "",
      }));
    }
    if (key === "startDate") {
      setStates((prevState) => ({
        ...prevState,
        ["endDate"]: "",
        ["cutOffDate"]: "",
        ["dateOfPoll"]: "",
      }));
    }
    if (key === "endDate") {
      setStates((prevState) => ({
        ...prevState,
        ["cutOffDate"]: "",
        ["dateOfPoll"]: "",

      }));
    }
    if (key === "cutOffDate") {
      setStates((prevState) => ({
        ...prevState,
        ["dateOfPoll"]: "",

      }));
    }
  };
  const onFinalize = async () => {
    let error = {};
    if (!states.electionType || states.electionType === "") {
      error["electionType"] = "This field is required";
    }
    if (!states.constituenctType || states.constituenctType === "") {
      error["constituenctType"] = "This field is required";
    }
    if (!states.statePhase || states.statePhase === "") {
      error["statePhase"] = "This field is required";
    }
    if (!selected || selected.length === 0) {
      error["constituency"] = "This field is required";
    }
    if (!states.dateOfPoll || states.dateOfPoll === "") {
      error["dateOfPoll"] = "This field is required";
    }
    if (!states.dateOfCompletion || states.dateOfCompletion === "") {
      error["dateOfCompletion"] = "This field is required";
    }
    if (!states.selectPhase || states.selectPhase === "") {
      error["selectPhase"] = "This field is required";
    }
    if (!states.state || states.state === "") {
      error["state"] = "This field is required";
    }
    if (!states.startDate || states.startDate === "") {
      error["startDate"] = "This field is required";
    }
    if (!states.cutOffDate || states.cutOffDate === "") {
      error["cutOffDate"] = "This field is required";
    }
    if (!states.endDate || states.endDate === "") {
      error["endDate"] = "This field is required";
    }
    if (!states.erollFinalisationDate || states.erollFinalisationDate === "") {
      error["erollFinalisationDate"] = "This field is required";
    }
    if (!states.startTime || states.startTime === "") {
      error["startTime"] = "This field is required";
    }
    if (!states.endTime || states.endTime === "") {
      error["endTime"] = "This field is required";
    }
    if (!states.Date_of_Announcement_of_Election || states.Date_of_Announcement_of_Election === "") {
      error["Date_of_Announcement_of_Election"] = "This field is required";
    }
    if (!states.erollFinalisationTime || states.erollFinalisationTime === "") {
      error["erollFinalisationTime"] = "This field is required";
    }
    if (!states.cutOffTime || states.cutOffTime === "") {
      error["cutOffTime"] = "This field is required";
    }
    if (Object.keys(error).length) {
      setError(error);
      setShowConfirmationPopup(false)
      return;
    }
    let tableData2 = []
    selected.map(item => {
      tableData2.push({
        "S_No": 1,
        "stateCd": states.state,
        "electionType": states.electionType,
        "constType": states.constituenctType,
        "constNo": item.value,
        "phaseNo": states.selectPhase,
        "statePhaseNo": states.statePhase,
        "gazetteDate": moment(new Date(states.Date_of_Announcement_of_Election)).format('DD-MM-YYYY'),
        "startDateTime": moment(new Date(states.startDate)).format('DD-MM-YYYY ') + moment(states?.startTime, "HH:mm").format("hh:mm A"),
        "endDateTime": moment(new Date(states.endDate)).format('DD-MM-YYYY ') + moment(states?.endTime, "HH:mm").format("hh:mm A"),
        "datePoll": moment(new Date(states.dateOfPoll)).format('DD-MM-YYYY'),
        "dateOfCompletion": moment(new Date(states.dateOfCompletion)).format('DD-MM-YYYY'),
        "cutOffDateTime": moment(new Date(states.cutOffDate)).format('DD-MM-YYYY ') + moment(states?.cutOffTime, "HH:mm").format("hh:mm A"),
        "erollFinalDateTime": moment(new Date(states.erollFinalisationDate)).format('DD-MM-YYYY ') + moment(states?.erollFinalisationTime, "HH:mm").format("hh:mm A"),
      });
    })
    // setTableData(tableData2)
    saveDetails(tableData2).unwrap().then((res) => {
      onSuccess(res.message);
      setStates(initialState)
      setSelected([]);
      getElectionData()
    })
    setShowConfirmationPopup(false)
  };
  const onUpdateAnnounceDetail = async () => {
    let error = {};
    if (!states.electionType || states.electionType === "") {
      error["electionType"] = "This field is required";
    }
    if (!states.constituenctType || states.constituenctType === "") {
      error["constituenctType"] = "This field is required";
    }
    if (!states.statePhase || states.statePhase === "") {
      error["statePhase"] = "This field is required";
    }
    if (!selected || selected.length === 0) {
      error["constituency"] = "This field is required";
    }
    if (!states.dateOfPoll || states.dateOfPoll === "") {
      error["dateOfPoll"] = "This field is required";
    }
    if (!states.dateOfCompletion || states.dateOfCompletion === "") {
      error["dateOfCompletion"] = "This field is required";
    }
    if (!states.selectPhase || states.selectPhase === "") {
      error["selectPhase"] = "This field is required";
    }
    if (!states.state || states.state === "") {
      error["state"] = "This field is required";
    }
    if (!states.Date_of_Announcement_of_Election || states.Date_of_Announcement_of_Election === "") {
      error["Date_of_Announcement_of_Election"] = "This field is required";
    }
    if (!states.startDate || states.startDate === "") {
      error["startDate"] = "This field is required";
    }
    if (!states.cutOffDate || states.cutOffDate === "") {
      error["cutOffDate"] = "This field is required";
    }
    if (!states.endDate || states.endDate === "") {
      error["endDate"] = "This field is required";
    }
    if (!states.erollFinalisationDate || states.erollFinalisationDate === "") {
      error["erollFinalisationDate"] = "This field is required";
    }
    if (!states.startTime || states.startTime === "") {
      error["startTime"] = "This field is required";
    }
    if (!states.endTime || states.endTime === "") {
      error["endTime"] = "This field is required";
    }
    if (!states.erollFinalisationTime || states.erollFinalisationTime === "") {
      error["erollFinalisationTime"] = "This field is required";
    }
    if (!states.cutOffTime || states.cutOffTime === "") {
      error["cutOffTime"] = "This field is required";
    }
    if (Object.keys(error).length) {
      setError(error);
      setShowConfirmationPopupForUpdateDetail(false)
      return;
    }
    let tableData2 = []
    selected.map(item => {
      tableData2.push({
        "S_No": 1,
        "stateCd": states.state,
        "electionType": states.electionType,
        "constType": states.constituenctType,
        "constNo": item.value,
        "phaseNo": states.selectPhase,
        "statePhaseNo": states.statePhase,
        "Date_of_Announcement_of_Election":moment(new Date(states.Date_of_Announcement_of_Election)).format('DD-MM-YYYY'),
        "startDateTime": moment(new Date(states.startDate)).format('DD-MM-YYYY ') + moment(states?.startTime, "HH:mm").format("hh:mm A"),
        "endDateTime": moment(new Date(states.endDate)).format('DD-MM-YYYY ') + moment(states?.endTime, "HH:mm").format("hh:mm A"),
        "datePoll": moment(new Date(states.dateOfPoll)).format('DD-MM-YYYY'),
        "cutOffDateTime": moment(new Date(states.cutOffDate)).format('DD-MM-YYYY ') + moment(states?.cutOffTime, "HH:mm").format("hh:mm A"),
        "erollFinalDateTime": moment(new Date(states.erollFinalisationDate)).format('DD-MM-YYYY ') + moment(states?.erollFinalisationTime, "HH:mm").format("hh:mm A"),
      });
    })
    setTableData(tableData2)

    updateAnnounceDetail({
      "phaseNo": states?.selectPhase,
        "statePhaseNo": states?.statePhase,
      "id":updateUserData.id,
      "gazetteDate":moment(new Date(states.Date_of_Announcement_of_Election)).format('DD-MM-YYYY'),
      "startDateTime": moment(new Date(states.startDate)).format('DD-MM-YYYY ') + moment(states?.startTime, "HH:mm").format("hh:mm A"),
      "endDateTime": moment(new Date(states.endDate)).format('DD-MM-YYYY ') + moment(states?.endTime, "HH:mm").format("hh:mm A"),
      "datePoll": moment(new Date(states.dateOfPoll)).format('DD-MM-YYYY'),
      "dateOfCompletion": moment(new Date(states.dateOfCompletion)).format('DD-MM-YYYY'),
      "cutOffDateTime": moment(new Date(states.cutOffDate)).format('DD-MM-YYYY ') + moment(states?.cutOffTime, "HH:mm").format("hh:mm A"),
      "erollFinalDateTime": moment(new Date(states.erollFinalisationDate)).format('DD-MM-YYYY ') + moment(states?.erollFinalisationTime, "HH:mm").format("hh:mm A"),
    }).unwrap().then((res) => {
      setShowConfirmationPopupForUpdateDetail(false)
      onSuccess(res.message);
      setStates(initialState)
      setSelected([]);
    })
    setShowConfirmationPopup(false)
  };


  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };
  const electionTypeOp = [
    { value: "", label: "Select Election Type" },
    { value: "General", label: "General" },
    { value: "Bye", label: "Bye" },
  ];


  const constituenctTypeOp = [
    { value: "", label: "Select Constituency Type" },
    { value: "AC", label: "AC" },
    { value: "PC", label: "PC" },
  ];
  const selectPhaseOp = [
    { value: "", label: "Select Phase" },
    { value: "1", label: "1" },
    { value: "1A", label: "1A" },
    { value: "1B", label: "1B" },
    { value: "1C", label: "1C" },
    { value: "2", label: "2" },
    { value: "2A", label: "2A" },
    { value: "2B", label: "2B" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
  ];
  const statePhaseOp = [
    { value: "", label: "Select State Phase" },
    { value: "1", label: "1" },
    { value: "1A", label: "1A" },
    { value: "1B", label: "1B" },
    { value: "1C", label: "1C" },
    { value: "2", label: "2" },
    { value: "2A", label: "2A" },
    { value: "2B", label: "2B" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
  ];
  const stateList = [{ value: "", label: "Select State" }];
  const acList = [];
  const { data: Acdata } = useGetConstituencyRequestQuery(states.state, {
    skip: states.constituenctType === "AC" ? false : true,
  });
  const { data: Pcdata } = useGetPcByStateQuery(states.state, {
    skip: states.constituenctType === "PC" ? false : true,
  });
  if (states.constituenctType === "AC") {
    Acdata?.map((item) => {
      acList.push({
        label: `${item.asmblyNo} - ${item.asmblyName}`,
        value: item.asmblyNo,
      });
    });
  }
  if (states.constituenctType === "PC") {
    Pcdata?.map((item) => {
      acList.push({
        label: `${item.prlmntNo} - ${item.parliamentName}`,
        value: item.prlmntNo,
      });
    });
  }
  getAllState?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    });
  });

  const handleDownload = () => {
    downloadExcel({
      fileName: "AnnounceElection details",
      sheet: "AnnounceElection",
      tablePayload: {
        header: tableHeader,
        body: tableData,
      },
    });
  };
  const convertDate = (date) => {
    var priorDate = new Date(
      new Date(date).setDate(new Date(date).getDate() + 1)
    );
    return priorDate;
  };

  const subtractDate = (date) => {
    var priorDate = new Date(
      new Date(date).setDate(new Date(date).getDate() - 1)
    );
    return priorDate;
  };

  return (
    <div className="Announce">
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          onClose={() => {
            setShowConfirmationPopup(false);
          }}
          size="500px"
          closeIcon={false}
          modalTitle={"Do you want to finalize ?"}
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={() => {
                setShowConfirmationPopup(false);
              }}
              yesOption={onFinalize}
            />
          }
        />
      }
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopupForUpdateDetail}
          onClose={() => {
            setShowConfirmationPopupForUpdateDetail(false);
          }}
          size="500px"
          closeIcon={false}
          modalTitle={"Are you Sure you want to Update?"}
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={() => {
                setShowConfirmationPopup(false);
              }}
              yesOption={onUpdateAnnounceDetail}
            />
          }
        />
      }
      <div className="row">
        <div className="col-md-4 ml-3 pt-4">
          <label className="requiredMark">Election Type</label>
        </div>
        <div className="col-md-4 dropdown">
          <SelectField
            name="electionType"
            inputClass="col-md-8"
            labelClass="col-md-8"
            disabled={updateUserData ? true : false}
            value={states.electionType}
            handleChange={(val) => handleChange("electionType", val)}
            options={electionTypeOp}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("electionType", val)}
            Error={Error}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-4 ml-3 pt-4">
          <label className="requiredMark">State</label>
        </div>
        <div className="col-md-4 dropdown">
          <SelectField
            className="col-md-6"
            inputClass="col-md-8"
            labelClass="col-md-8"
            name="state"
            disabled={updateUserData ? true : false}
            value={states.state}
            handleChange={(val, i) => handleChange("state", val, i)}
            options={stateList}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("state", val)}
            Error={Error}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 ml-3 pt-4">
          <label className="requiredMark">Constituency Type</label>
        </div>
        <div className="col-md-4 dropdown">
          <SelectField
            name="constituenctType"
            inputClass="col-md-8"
            labelClass="col-md-8"
            value={states.constituenctType}
            disabled={updateUserData ? true : false}
            handleChange={(val) => handleChange("constituenctType", val)}
            options={constituenctTypeOp}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("constituenctType", val)}
            Error={Error}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 ml-3 pt-4">
          <label className="requiredMark">Constituency</label>
        </div>
        <div className={`col-md-4 mt-4 singleComponent_dropdown ${updateUserData?"multiSelectIsdisable":""}`}>
          <MultiSelectCheckBox
            options={acList.sort((a, b) => a.value - b.value)}
            name="constituency"
            value={selected}
            className={"col-md-8"}
            onChange={setSelected}
            disabled={updateUserData ? true : false}
            labelledBy="Select"
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("constituency", val)}
            Error={Error}
          ></MultiSelectCheckBox>
        </div>
      </div>
      <div className="row ">
        <div className="col-md-4 ml-3 pt-4">
          <label className="requiredMark">Phase No</label>
        </div>
        <div className="col-md-4 dropdown">
          <SelectField
            name="selectPhase"
            inputClass="col-md-8"
            labelClass="col-md-8"
            value={states.selectPhase}
            // disabled={updateUserData ? true : false}
            handleChange={(val) => handleChange("selectPhase", val)}
            options={selectPhaseOp}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("selectPhase", val)}
            Error={Error}
          />
        </div>
      </div>
      <div className="row ">
        <div className="col-md-4 ml-3 pt-4">
          <label className="requiredMark">State Phase No</label>
        </div>
        <div className="col-md-4 dropdown">
          <SelectField
            name="statePhase"
            inputClass="col-md-8"
            labelClass="col-md-8"
            value={states.statePhase}
            // disabled={updateUserData ? true : false}
            handleChange={(val) => handleChange("statePhase", val)}
            options={statePhaseOp}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("statePhase", val)}
            Error={Error}
          />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-4 ml-3 ">
          <label className="requiredMark">Date of Announcement of Election</label>
        </div>
        <div className="col-md-3 ">
          <DateInput
            label=""
            inputClass="col-md-12"
            value={states.Date_of_Announcement_of_Election}
            // disabled={states.cutOffDate === "" || states.cutOffDate === null}
            onChange={(val) => handleChange("Date_of_Announcement_of_Election", val)}
            name="Date_of_Announcement_of_Election"
            // min={
            //   states?.startDate &&
            //   convertDate(states?.startDate).toISOString().split("T")[0]
            // }
            // max={
            //   states?.cutOffDate &&
            //   subtractDate(states?.cutOffDate).toISOString().split("T")[0]
            // }
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("Date_of_Announcement_of_Election", val)}
            Error={Error}
          />
          {error.Date_of_Announcement_of_Election && (
            <div className="text-danger errormsg ml-3">{error.Date_of_Announcement_of_Election}</div>
          )}
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-4 ml-3 ">
          <label className="requiredMark">Last Date of making nominations</label>
        </div>
        <div className="col-md-3">
          <DateInput
            label=""
            inputClass="col-md-12"
            value={states.erollFinalisationDate}
            onChange={(val) => handleChange("erollFinalisationDate", val)}
            disabled={
              states.Date_of_Announcement_of_Election === "" ||
              states.Date_of_Announcement_of_Election === null
            }
            name="erollFinalisationDate"
            min={
              states?.Date_of_Announcement_of_Election &&
              convertDate(states?.Date_of_Announcement_of_Election).toISOString().split("T")[0]
            }
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("erollFinalisationDate", val)}
            Error={Error}
          />
          {error.erollFinalisationDate && (
            <div className="text-danger errormsg ml-3">
              {error.erollFinalisationDate}
            </div>
          )}
        </div>
        <div
          className="col-md-2"
          style={{ position: "relative", right: "43px" }}
        >
          <DateInput
            type="time"
            label=""
            inputClass="col-md-12"
            value={states.erollFinalisationTime}
            onChange={(val) => handleChange("erollFinalisationTime", val)}
            name="erollFinalisationTime"
            disabled={
              states.Date_of_Announcement_of_Election === "" ||
              states.Date_of_Announcement_of_Election === null
            }
            min={new Date().toISOString().split("T")[0]}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("erollFinalisationTime", val)}
            Error={Error}
          />
          {error.erollFinalisationTime && (
            <div className="text-danger errormsg ml-3">
              {error.erollFinalisationTime}
            </div>
          )}
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-4 ml-3 ">
          <label className="requiredMark">Last date for the withdrawal of candidates</label>
        </div>
        <div className="col-md-3  ">
          <DateInput
            label=""
            inputClass="col-md-12"
            value={states.startDate}
            disabled={
              states.erollFinalisationDate === "" ||
              states.erollFinalisationDate === null
            }
            onChange={(val) => handleChange("startDate", val)}
            name="startDate"
            min={
              states?.erollFinalisationDate &&
              convertDate(states?.erollFinalisationDate)
                .toISOString()
                .split("T")[0]
            }
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("startDate", val)}
            Error={Error}
          />
          {error.startDate && (
            <div className="text-danger errormsg ml-3">{error.startDate}</div>
          )}
        </div>
        <div
          className="col-md-2"
          style={{ position: "relative", right: "43px" }}
        >
          <DateInput
            type="time"
            label=""
            inputClass="col-md-12"
            value={states.startTime}
            onChange={(val) => handleChange("startTime", val)}
            disabled={
              states.erollFinalisationDate === "" ||
              states.erollFinalisationDate === null
            }
            name="startTime"
            min={new Date().toISOString().split("T")[0]}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("startTime", val)}
            Error={Error}
          />
          {error.startTime && (
            <div className="text-danger errormsg ml-3">{error.startTime}</div>
          )}
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-4 ml-3  ">
          <label className="requiredMark">End Date & Time of downloading</label>
        </div>
        <div className="col-md-3 ">
          <DateInput
            label=""
            inputClass="col-md-12"
            value={states.endDate}
            disabled={states.startDate === "" || states.startDate === null}
            onChange={(val) => handleChange("endDate", val)}
            name="endDate"
            min={
              states?.startDate &&
              convertDate(states?.startDate).toISOString().split("T")[0]
            }
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("endDate", val)}
            Error={Error}
          />
          {error.endDate && (
            <div className="text-danger errormsg ml-3">{error.endDate}</div>
          )}
        </div>
        <div
          className="col-md-2"
          style={{ position: "relative", right: "43px" }}
        >
          <DateInput
            type="time"
            label=""
            inputClass="col-md-12"
            value={states.endTime}
            onChange={(val) => handleChange("endTime", val)}
            disabled={states.startDate === "" || states.startDate === null}
            name="endTime"
            min={new Date().toISOString().split("T")[0]}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("endTime", val)}
            Error={Error}
          />
          {error.endTime && (
            <div className="text-danger errormsg ml-3">{error.endTime}</div>
          )}
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-md-4 ml-3 ">
          <label className="requiredMark">Cut-off Date & Time</label>
        </div>
        <div className="col-md-3 ">
          <DateInput
            label=""
            inputClass="col-md-12"
            value={states.cutOffDate}
            disabled={states.endDate === "" || states.endDate === null}
            onChange={(val) => handleChange("cutOffDate", val)}
            name="cutOffDate"
            min={
              states?.endDate &&
              convertDate(states?.endDate).toISOString().split("T")[0]
            }
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("cutOffDate", val)}
            Error={Error}
          />
          {error.cutOffDate && (
            <div className="text-danger errormsg ml-3">{error.cutOffDate}</div>
          )}
        </div>
        <div
          className="col-md-2"
          style={{ position: "relative", right: "43px" }}
        >
          <DateInput
            type="time"
            label=""
            inputClass="col-md-12"
            value={states.cutOffTime}
            onChange={(val) => handleChange("cutOffTime", val)}
            disabled={states.endDate === "" || states.endDate === null}
            name="cutOffTime"
            min={new Date().toISOString().split("T")[0]}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("cutOffTime", val)}
            Error={Error}
          />
          {error.cutOffTime && (
            <div className="text-danger errormsg ml-3">{error.cutOffTime}</div>
          )}
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-4 ml-3 ">
          <label className="requiredMark">Date of Poll</label>
        </div>
        <div className="col-md-3 ">
          <DateInput
            label=""
            inputClass="col-md-12"
            value={states.dateOfPoll}
            disabled={states.cutOffDate === "" || states.cutOffDate === null}
            onChange={(val) => handleChange("dateOfPoll", val)}
            name="dateOfPoll"
            min={
              states?.startDate &&
              convertDate(states?.startDate).toISOString().split("T")[0]
            }
            max={
              states?.cutOffDate &&
              subtractDate(states?.cutOffDate).toISOString().split("T")[0]
            }
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("dateOfPoll", val)}
            Error={Error}
          />
          {error.dateOfPoll && (
            <div className="text-danger errormsg ml-3">{error.dateOfPoll}</div>
          )}
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-4 ml-3 ">
          <label className="requiredMark">Date of Compeletion of Election</label>
        </div>
        <div className="col-md-3 ">
          <DateInput
            label=""
            inputClass="col-md-12"
            value={states.dateOfCompletion}
            disabled={states.dateOfPoll === "" || states.dateOfPoll === null}
            onChange={(val) => handleChange("dateOfCompletion", val)}
            name="dateOfCompletion"
            min={
              states?.cutOffDate &&
              convertDate(states?.cutOffDate).toISOString().split("T")[0]
            }
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("dateOfCompletion", val)}
            Error={Error}
          />
          {error.dateOfCompletion && (
            <div className="text-danger errormsg ml-3">{error.dateOfCompletion}</div>
          )}
        </div>
      </div>

      <div className="finalize_button col-md-12 mt-4 mb-3 row">
        {
          !updateUserData ? (<div className="col-md-2">
            <Button
              className="btn-class"
              value="Finalize"
              onClick={() => setShowConfirmationPopup(true)}
            />
          </div>) : (<div className="col-md-2">
            <Button
              className="btn-class"
              value="Update"
              onClick={() => setShowConfirmationPopupForUpdateDetail(true)}
            />
          </div>)
        }

        {/* <button type="button"
                    className="btn btn-primary btn-sm announce_download_single_button"
                    onClick={handleDownload}>Download<span className="pl-2"><i class="fa-solid fa-download"></i></span>
                </button> */}
        <div
          className="col-md-10"
          style={{ display: "flex", justifyContent: "end" }}
        >
          <img
            src={excelIcon}
            width="40px"
            height="30px"
            onClick={handleDownload}
          />
        </div>
      </div>
      {isShowing ? (
        <div className="col-md-12">
          <Table
            placeholder="Search"
            globalsearch={true}
            selectall={true}
            columns={columns}
            emptyMessage="No Record Found"
            data={tableData?.length === 0 ? [] : tableData}
            size={5}
            tableClassNameCheck="contenttable-eroll"
            pagination
            records
            gotopage
            rows
            numberrows={totalNoOfRecords}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default SingleComponent;
